import { InboundFaxMemberDto } from "@app/core/model";

// Simplified model to not be dependent on InboundFaxDto, but needed to maintain
// some artifacts for backwards compatibility with Document.Gateway migration.
// Can clean up more once we deprecate the flag.
export interface InboundFaxesTableModel {
  inboundFaxId: string;
  documentStorageLocation: string;
  fileSizeBytes: number;
  faxFolderId: string;
  faxFolderName: string;
  faxFolderIdModifiedDate: Date;
  assignedUserId: string | null;
  assignedUserName: string | null;
  memberId: string | null;
  memberSubscriberNumber: string | null;
  memberFullName: string;
  memberDOB: string | null;
  memberTenantId: string | null;
  memberLobId: string | null;
  memberBenefitPlan: string | null;
  faxReceivedDateTime: Date;
  statusId: string | null;
  statusName: string | null;
  requestTypeId: string | null;
  requestTypeName: string | null;
  noteId: string | null;
  noteConfig: any;
  isArchived: boolean;
  archivedReasonId: string | null;
  archivedReasonDescription: string | null;
  restoreArchive: boolean;
  isPreviewLoading: boolean;
  member: InboundFaxMemberDto | null;
}

// Keep these in sync with the model above. Trying to minimize hard coding references.
export enum InboundFaxesTableModelKeys {
  inboundFaxId = 'inboundFaxId',
  faxFolderId = 'faxFolderId',
  faxFolderName = 'faxFolderName',
  faxReceivedDateTime = 'faxReceivedDateTime',
  faxFolderIdModifiedDate ='faxFolderIdModifiedDate',
  memberId = 'memberId',
  memberSubscriberNumber ='memberSubscriberNumber',
  memberFullName = 'memberFullName',
  memberDOB = 'memberDOB',
  memberTenantId = 'memberTenantId',
  memberLobId = 'memberLobId',
  statusId = 'statusId',
  statusName = 'statusName',
  requestTypeId = 'requestTypeId',
  requestTypeName = 'requestTypeName',
  assignedUserId = 'assignedUserId',
  assignedUserName = 'assignedUserName',
  isArchived = 'isArchived',
  archivedReasonId = 'archivedReasonId',
  archivedReasonDescription = 'archivedReasonDescription',
  restoreArchive = 'restoreArchive',
  noteId = 'noteId',
  documentStorageLocation = 'documentStorageLocation',
}
